import { Injectable, signal } from '@angular/core';
import { MenuItem } from 'primeng/api';

/**
 * This service provides a way for components to update
 * the "extra nav items" area of the global navigation menu
 */
@Injectable({
  providedIn: 'root',
})
export class GlobalNavService {
  extraNavItems = signal<MenuItem[] | null>(null);

  /**
   * Provide a list of items that should appear in the main navigation
   * @param items
   */
  setExtraNavItems(items: MenuItem[] | null) {
    this.extraNavItems.set(items);
  }

  /**
   * Convenience method for clearing extra navigation items
   */
  clearExtraNavItems() {
    this.setExtraNavItems(null);
  }
}
